/**
 * List of supported languages.
 * See: https://zopim.zendesk.com/entries/23042000-Supported-Languages-on-the-Chat-Widget
 * @type {string[]}
 */
const zopimLanguages = [
  'sq',
  'ar',
  'az',
  'bg',
  'ca',
  'zh_CN',
  'zh_TW',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'et',
  'fi',
  'fr',
  'ka',
  'de',
  'el',
  'he',
  'hi',
  'hu',
  'is',
  'id',
  'it',
  'ja',
  'ko',
  'ku',
  'lv',
  'lt',
  'mk',
  'ms',
  'nb',
  'fa',
  'pl',
  'pt',
  'pt_BR',
  'ro',
  'ru',
  'sr',
  'sk',
  'sl',
  'es',
  'sv',
  'tl',
  'th',
  'tr',
  'uk',
  'ur',
  'vi',
];

/**
 * Default zopim locale.
 * @type {string}
 */
const fallbackLanguage = 'en';

/**
 * Map current locale to zopim's language.
 * @param locale
 * @return {string|*}
 */
const mapLocaleToZopimLanguage = function(locale) {
  if (!locale) {
    return fallbackLanguage;
  }

  if (zopimLanguages.indexOf(locale) > -1) {
    return locale;
  }

  const language = locale.substring(0, 2);
  return zopimLanguages.indexOf(language) > -1 ? language : fallbackLanguage;
};

export default function() {
  if (ACC.liveChatEnabledOnSite && ACC.liveChatOnPage) {
    window.addEventListener('load', function() {
      /* Start of Zopim Live Chat Script */
      window.$zopim ||
      (function(d, s) {
        let z = (window.$zopim = function(c) {
            z._.push(c);
          }),
          $ = (z.s = d.createElement(s)),
          e = d.getElementsByTagName(s)[0];
        z.set = function(o) {
          z.set._.push(o);
        };
        z._ = [];
        z.set._ = [];
        $.async = !0;
        $.setAttribute('charset', 'utf-8');
        $.src = 'https://v2.zopim.com/?' + ACC.liveChatApiKey;
        z.t = +new Date();
        $.type = 'text/javascript';
        e.parentNode.insertBefore($, e);
      })(document, 'script');
      /* End of Zopim Live Chat Script */

      // Our customizations for the livechat widget
      window.$zopim(function() {
        const language = mapLocaleToZopimLanguage(ACC.languageISO);
        const liveChat = window.$zopim.livechat;

        liveChat.setLanguage(language);
        liveChat.addTags(ACC.languageISO);
        liveChat.button.setOffsetVerticalMobile(58);
        liveChat.button.setOffsetVertical(58);
        liveChat.button.setHideWhenOffline(ACC.liveChatHideWhenOffline);
        if (ACC.isB2Bsite === 'true') {
          liveChat.setName(ACC.currentUserName);
          liveChat.setEmail(ACC.currentUserEmail);
          liveChat.addTags(ACC.currentB2BUnit);
        }

        // To fix the chat blink on first load, set initial status to 'offline'
        liveChat.setStatus('offline');
        $.ajax({
          type: 'GET',
          url: `${ACC.isB2Bsite ? '/b2b' : ''}/live-chat-departments/departments/`,
          success: function(departments) {
            if (!departments.length) return;
            departments.forEach((department) => {
              department.status = liveChat.departments.getDepartment(parseInt(department.id)).status;
            });
            liveChat.departments.filter.apply(
              this,
              departments
                .filter((department) => department.status === 'online')
                .map((department) => department.departmentName)
            );
            liveChat.setOnConnected(function() {
              let previousStatus;
              liveChat.setOnStatus(function() {
                const hasDepartmentsOnline = departments.some((department) => department.status === 'online');
                const newStatus = hasDepartmentsOnline ? 'online' : 'offline';
                if (!previousStatus || newStatus !== previousStatus) {
                  liveChat.setStatus(newStatus);
                  previousStatus = newStatus;
                }
              });
            });
          },
          error: function(e) {
            console.error(e);
          },
        });
      });

      $('.zopim').hide();

      // Zopim does not provide styling customization and it cannot be styled using CSS
      // Leaving us with the sole option of JS intervention
      const checkforZopimChatButtonMod = function() {
        const $zopim = $('.zopim');
        if ($zopim && $zopim.length === 2) {
          $zopim.css('border-bottom-left-radius', '5px');
          $zopim.css('border-bottom-right-radius', '5px');
        } else {
          setTimeout(function() {
            checkforZopimChatButtonMod();
          }, 200);
        }
      };
      checkforZopimChatButtonMod();
    });
  }
}
